import { render, staticRenderFns } from "./FloatingSupport.vue?vue&type=template&id=2d51ca69&scoped=true"
import script from "./FloatingSupport.vue?vue&type=script&lang=js"
export * from "./FloatingSupport.vue?vue&type=script&lang=js"
import style0 from "./FloatingSupport.vue?vue&type=style&index=0&id=2d51ca69&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d51ca69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-kr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d51ca69')) {
      api.createRecord('2d51ca69', component.options)
    } else {
      api.reload('2d51ca69', component.options)
    }
    module.hot.accept("./FloatingSupport.vue?vue&type=template&id=2d51ca69&scoped=true", function () {
      api.rerender('2d51ca69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FloatingSupport.vue"
export default component.exports